/**
 * Aceleres -- "Número da Equipe".
 *
 * Identificação única no frontend. O backend serializa a marcação em
 * custom_attributes.numero_equipe tanto no contato quanto em meta.sender das
 * conversas, então o mesmo helper atende o painel do contato e a listagem
 * lateral, e continua correto após recarregar a página.
 */

const TEAM_NUMBER_KEY = 'numero_equipe';
// Alguns getters do store camelizam custom_attributes em profundidade
// (contacts/getContactsList), então a mesma marcação chega como numeroEquipe.
const TEAM_NUMBER_KEY_CAMEL = 'numeroEquipe';

const castBoolean = value => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    return ['true', '1', 't', 'yes'].includes(value.trim().toLowerCase());
  }
  return false;
};

export const isTeamNumberContact = contact => {
  if (!contact) return false;

  const customAttributes =
    contact.customAttributes || contact.custom_attributes || {};
  const additionalAttributes =
    contact.additionalAttributes || contact.additional_attributes || {};

  return castBoolean(
    customAttributes[TEAM_NUMBER_KEY] ??
      customAttributes[TEAM_NUMBER_KEY_CAMEL] ??
      additionalAttributes[TEAM_NUMBER_KEY] ??
      additionalAttributes[TEAM_NUMBER_KEY_CAMEL]
  );
};

export const isTeamNumberConversation = conversation => {
  if (!conversation) return false;

  const sender = conversation.meta?.sender || conversation.contact;
  return isTeamNumberContact(sender);
};

export default { isTeamNumberContact, isTeamNumberConversation };
